// import organizationType from '@/utils/organizationType'

const counterPartyView_ColumnDefs = [
  {
    headerName: 'Code',
    field: 'organizationCode',
    width: 160,
    cellRenderer: 'agGroupCellRenderer',
  },
  { headerName: 'Desc', field: 'organizationDesc', width: 200 },

  { headerName: 'EffectiveFromDate', field: 'effectiveFromDate', width: 160 },
  { headerName: 'EffectiveToDate', field: 'effectiveToDate', width: 160 },

  { headerName: 'LastModifiedBy', field: 'lastModifiedBy', width: 140 },
  { headerName: 'LastModifiedOn', field: 'lastModifiedOn', width: 160 },
  {
    headerName: 'Action',
    field: 'edit',
    width: 80,
    filter: false,
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      fn: () => {},
    },
  },
]
/* 
const detailColumnDefs = [
  {
    headerName: 'Type',
    width: 180,
    valueGetter: (params) => {
      if (params.data) {
        if (params.data.organizationTypeId === organizationType.CUSTODIAN) {
          return 'CUSTODIAN'
        }
        if (params.data.organizationTypeId === organizationType.COUNTERPARTY) {
          return 'COUNTERPARTY'
        }
      }
      return ''
    },
  },
  { headerName: 'Fund', field: 'fundCode', width: 140 },
  {
    headerName: 'Status',
    field: 'statusCode',
    width: 160,
    valueGetter: (params) => {
      if (params.data) {
        if (params.data.statusCode === 'A') {
          return 'ACTIVE'
        }
        if (params.data.statusCode === 'I') {
          return 'INACTIVE'
        }
      }
      return ''
    },
    // editable: true,
    // tooltipValueGetter: () => 'double click to edit',
    // cellRenderer: (params) => {
    //   const value = params.value
    //   return `<span style="text-decoration: underline; color: #1890ff; cursor: pointer;">${value}</span>`
    // },
    // cellEditorSelector: (params) => {
    //   if (params.data) {
    //     return {
    //       component: 'agRichSelectCellEditor',
    //       params: {
    //         values: ['A', 'I'],
    //         formatValue: (value) =>
    //           value === 'A' ? 'ACTIVE' : value === 'I' ? 'INACTIVE' : '',
    //       },
    //     }
    //   }
    //   return null
    // },
  },
  // { headerName: 'LastModifiedBy', field: 'lastModifiedBy', width: 140 },
  // { headerName: 'LastModifiedOn', field: 'lastModifiedOn', width: 160 },
  {
    headerName: 'Action',
    field: 'edit',
    width: 80,
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      fn: () => {},
    },
  },
] */
export { counterPartyView_ColumnDefs }
